import { createPinia } from 'pinia';
import useAppStore from './modules/app';
import useStation from './modules/station';
import useTabBarStore from './modules/tab-bar';
import useUserStore from './modules/user';

const pinia = createPinia();

export { useAppStore, useUserStore, useTabBarStore, useStation };
export default pinia;
